import { FC } from "react";

/** Inward-pointing arrows — the "minimise" counterpart to the expand icon. */
export const IconMinimise: FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5.41667 12.0833V8.08333H1.41667M5.41667 8.08333L0.75 12.75M8.08333 1.41667V5.41667H12.0833M8.08333 5.41667L12.75 0.75" />
  </svg>
);

export default IconMinimise;
